import { lazy } from "react";

const Login = lazy(() =>
  import("../app/general").then((module) => ({ default: module.Login }))
);
const Pay = lazy(() =>
  import("../app/general").then((module) => ({ default: module.Pay }))
);
const Register = lazy(() =>
  import("../app/general").then((module) => ({ default: module.Register }))
);
const Reset = lazy(() =>
  import("../app/general").then((module) => ({ default: module.Reset }))
);

const Main = lazy(() =>
  import("../app/authority").then((module) => ({ default: module.Main }))
);
const VenueCreate = lazy(() =>
  import("../app/authority").then((module) => ({ default: module.VenueCreate }))
);
const VenueWholeCreate = lazy(() =>
  import("../app/authority").then((module) => ({
    default: module.VenueWholeCreate,
  }))
);
const Review = lazy(() =>
  import("../app/authority").then((module) => ({ default: module.Review }))
);
const Master = lazy(() =>
  import("../app/authority").then((module) => ({ default: module.Master }))
);
const EditMaster = lazy(() =>
  import("../app/authority").then((module) => ({ default: module.EditMaster }))
);
const Archive = lazy(() =>
  import("../app/authority").then((module) => ({ default: module.Archive }))
);
const Setting = lazy(() =>
  import("../app/authority").then((module) => ({ default: module.Setting }))
);
const Booking = lazy(() =>
  import("../app/authority").then((module) => ({ default: module.Booking }))
);
const Notes = lazy(() =>
  import("../app/authority").then((module) => ({ default: module.Notes }))
);
const Analytics = lazy(() =>
  import("../app/authority").then((module) => ({ default: module.Analytics }))
);
const Favourite = lazy(() =>
  import("../app/authority").then((module) => ({ default: module.Favourite }))
);
const Result = lazy(() =>
  import("../app/authority").then((module) => ({ default: module.Result }))
);

export interface RouteConfigDeclaration {
  /**
   * 当前路由路径
   */
  path: string;
  /**
   * 当前路由名称
   */
  name?: string;
  /**
   * 是否严格匹配路由
   */
  exact?: boolean;
  /**
   * 是否需要路由鉴权
   */
  auth?: boolean;
  /**
   * 是否需要路由重定向
   */
  isRedirect?: boolean;
  /**
   * 是否需要动态加载路由
   */
  isDynamic?: boolean;
  /**
   * 动态加载路由时的提示文案
   */
  loadingFallback?: string;
  /**
   * 路由组件
   */
  component: any;
  /**
   * 子路由
   */
  children?: RouteConfigDeclaration[];
}
let routes: RouteConfigDeclaration[] = [
  {
    path: "/login",
    component: Login,
    exact: true,
    auth: false,
  },
  {
    path: "/register",
    component: Register,
    exact: true,
    auth: false,
  },
  {
    path: "/pay",
    component: Pay,
    exact: true,
    auth: false,
  },
  {
    path: "/reset",
    component: Reset,
    exact: true,
    auth: false,
  },
  {
    path: "/*",
    component: Main,
    exact: false,
    children: [
      {
        path: "/venue",
        component: VenueCreate,
        exact: true,
        auth: false,
      },
      {
        path: "/create",
        component: VenueWholeCreate,
        exact: true,
        auth: false,
      },
      {
        path: "/copy",
        component: VenueWholeCreate,
        exact: true,
        auth: false,
      },
      {
        path: "/review",
        component: Review,
        exact: true,
        auth: false,
      },
      {
        path: "/master",
        component: Master,
        exact: true,
        auth: false,
      },
      {
        path: "/editmaster",
        component: EditMaster,
        exact: true,
        auth: false,
      },
      {
        path: "/archive",
        component: Archive,
        exact: true,
        auth: false,
      },
      {
        path: "/setting",
        component: Setting,
        exact: true,
        auth: false,
      },
      {
        path: "/booking",
        component: Booking,
        exact: true,
        auth: false,
      },
      {
        path: "/notes",
        component: Notes,
        exact: true,
        auth: false,
      },
      {
        path: "/analytics",
        component: Analytics,
        exact: true,
        auth: false,
      },
      {
        path: "/customer-favourite",
        component: Favourite,
        exact: true,
        auth: false,
      },
      {
        path: "/result",
        component: Result,
        exact: true,
        auth: false,
      },
    ],
  },
];

export default routes;
